import { render, staticRenderFns } from "./DomainBastion.vue?vue&type=template&id=6c1bba09&"
import script from "./DomainBastion.vue?vue&type=script&lang=js&"
export * from "./DomainBastion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports